import { useState } from "react";
import { faArrowLeft, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import Button from "../../../../Components/Common/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useSWRMutation from "swr/mutation";
import { FileApiUrls } from "../../../../Api/Auth/ApiUrls";
import {
  sendDeleteRequestAuth,
  // sendPutRequestAuth,
} from "../../../../Api/swrConfig";
import { toast } from "react-toastify";
import useToastError from "../../../../hooks/useErrorToast";
// import RadioInput from "../../../../Components/Common/RadioInput";

const ImagePreview = ({ file, onBack, folder }) => {
  const [imageLoading, setImageLoading] = useState(true); // State to track if the image is loading
  // const [fileType, setFileType] = useState(file.fileType); // State to manage selected file type
  const { showErrorToast } = useToastError();
  const handleCopy = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        toast.success("Copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  // Handle image load success
  const handleImageLoad = () => {
    setImageLoading(false); // Set loading state to false when the image is loaded
  };

  // Handle image load error
  const handleImageError = () => {
    setImageLoading(false); // Set loading state to false on error
  };

  // Handle file type change
  // const handleFileTypeChange = (_, value) => {
  //   const newFileType = value;
  //   setFileType(newFileType);

  //   // Make PUT request to update the file type
  //   trigger({ private: newFileType === "private" });
  // };

  // const { trigger } = useSWRMutation(
  //   FileApiUrls.edit(file.filename),
  //   sendPutRequestAuth,
  //   {
  //     onSuccess: (data) => {
  //       toast.success("Success");
  //     },
  //     onError: (error) => {
  //       showErrorToast(error);
  //     },
  //   }
  // );

  const { trigger: deleteTrigger, isMutating } = useSWRMutation(
    FileApiUrls.delete(file.filename, folder),
    sendDeleteRequestAuth,
    {
      onSuccess: (data) => {
        onBack();
        toast.success("Success");
      },
      onError: (error) => {
        showErrorToast(error);
      },
    }
  );
  const onDelete = () => {
    deleteTrigger(file.filename, folder);
  };
  return (
    <>
      <div className="flex justify-between gap-2">
        <Button onClick={onBack} size="small" className="mb-4">
          <span className="flex gap-2 items-center">
            <FontAwesomeIcon icon={faArrowLeft} />
            Back to List
          </span>
        </Button>
        {/* Delete Button */}
        <Button
          onClick={onDelete}
          size="small"
          className="mb-4 bg-red-500 hover:bg-red-600"
          isLoading={isMutating}
        >
          <span className="flex gap-2 items-center">
            <FontAwesomeIcon icon={faTrashAlt} />
            Delete
          </span>
        </Button>
      </div>
      <div className="flex flex-col lg:flex-row gap-8">
        {/* Left Part: Image Preview */}
        <div className="flex flex-col items-center lg:w-1/2 sm:min-h-[500px]">
          <div className="relative w-full max-w-[500px]">
            {/* Blue loading effect until image is loaded */}
            {imageLoading && (
              <div className="absolute inset-0 bg-gray-300 animate-pulse"></div>
            )}

            {file?.contentType.includes("video") ? (
              <video
                controls
                className="w-full h-auto rounded-lg shadow-md"
                onLoadedData={handleImageLoad}
                onError={handleImageError}
              >
                <source src={file.fileUrl} type={file.contentType} />
                Your browser does not support the video tag.
              </video>
            ) : file?.contentType === "application/pdf" ? (
              <img
                src={
                  "https://storage.googleapis.com/road-to-fe/uploads/1741110111744-5fb0db0b-ee21-4a9e-82f4-f09d87b3bbc6-pdfIcon.png"
                }
                alt={file.originalName}
                className="w-full h-auto rounded-lg shadow-md"
                onLoad={handleImageLoad}
                onError={handleImageError}
              />
            ) : (
              <img
                src={file.fileUrl}
                alt={file.originalName}
                className="w-full h-auto rounded-lg shadow-md"
                onLoad={handleImageLoad}
                onError={handleImageError}
              />
            )}
          </div>
        </div>

        {/* Right Part: File Details */}
        <div className="lg:w-1/2 flex flex-col gap-4">
          {/* File Details */}
          <div className="space-y-2 text-md">
            <p>
              <strong>Filename:</strong> {file.filename}
            </p>
            <p>
              <strong>Original Name:</strong> {file.originalName}
            </p>
            <div>
              <p>
                <strong>File URL:</strong> {file.fileUrl}
                <span>
                  <Button
                    onClick={() => handleCopy(file.fileUrl)}
                    children={"Copy"}
                    className="ml-2"
                  />
                </span>
              </p>
            </div>
            <p>
              <strong>Size:</strong> {Math.round(file.size / 1024)} KB
            </p>
            <p>
              <strong>Uploaded At:</strong>{" "}
              {new Date(file.uploadedAt).toLocaleString()}
            </p>
          </div>

          {/* File Type Selection */}
          {/* <RadioInput
            label="File Type:"
            options={[
              { label: "Public", value: "public" },
              { label: "Private", value: "private" },
            ]}
            onChange={handleFileTypeChange}
            checked={fileType}
          /> */}
        </div>
      </div>
    </>
  );
};

export default ImagePreview;
